<template>
  <ul :class="$style.nav">
    <li
      v-for="(el, index) in data"
      :id="`js-business-menu-${index}`"
      :key="index"
      @click="$emit('click', index)"
    >
      {{ el.title.join('、') }}
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default() {
        return []
      },
    },
  },
}
</script>

<style lang="less" module>
@default-color: #9b9b9b;
@hover-color: #606060;
@active-color: @primary;
@border-color: #eaeaea;

.nav {
  position: absolute;
  top: 1.5rem;
  right: 0.2rem;
  width: 3.2rem;
  user-select: none;

  li {
    display: flex;
    align-items: center;
    height: 1.05rem;
    border-left: 0.02rem solid @border-color;
    color: @default-color;
    cursor: pointer;

    &:not(:global(.active)):hover {
      color: @hover-color;

      &::before {
        background-color: @hover-color;
      }
    }

    &::before {
      .size(0.02rem);
      content: '';
      display: block;
      margin-left: 0.15rem;
      margin-right: 0.12rem;
      background-color: @default-color;
    }
  }

  :global(.active) {
    border-color: @active-color;
    color: @active-color;

    &::before {
      background-color: @active-color;
    }
  }
}
</style>
